import moment from "moment";

export const isExpired = (item) => {
	const now = moment();
	const endDate = moment(item?.baseAmountDetails?.convertedAt).add(
		item?.bonus?.triggerExpirationDays,
		"days"
	);
	return endDate < now;
};

export const isOverLimit = (item) => {
	if (item.walletContributions?.length > 0) {
		const amount = item?.walletContributions[0]?.amount.value;
		const limit = item?.bonus?.claimInfo?.userLimit;
		return amount > limit;
	}
};
